import { Dialog, DialogProps } from '@progress/kendo-react-dialogs';
import {
    useSchedulerEditItemPropsContext,
    useSchedulerEditItemRemoveItemContext,
    useSchedulerEditItemFormItemContext,
    useSchedulerEditItemShowRemoveDialogContext,
} from "@progress/kendo-react-scheduler";


export const CustomDialog = (props: DialogProps, newProps: any, deleteActivty: any) => {
    const editItemProps = useSchedulerEditItemPropsContext();
    const [, setRemoveItem] = useSchedulerEditItemRemoveItemContext();
    const [, setShowRemoveItemDialog] = useSchedulerEditItemShowRemoveDialogContext();
    const [, setFormItem] = useSchedulerEditItemFormItemContext();

    const handleRemoveClick = () => {
        // Sets the item to be removed
        setRemoveItem(editItemProps.dataItem);
        // Closes the form
        setFormItem(null);
        // Shows the remove confirmation dialog
        setShowRemoveItemDialog(true);
    };

    const CustomTitle = () => {
        return (
            <>
                <div className="container-fluid">
                    <div className="row">
                        <h6 className="col-10 pt-1 ps-0 fs-5 mb-0 text-black">Work Activity</h6>
                        {/*To show the only while updating the activity*/}
                        {
                            newProps.dataItem.id > 0 &&
                            (
                                <button className="btn btn-secondary btn-sm mt-0 col-2" onClick={handleRemoveClick}>Delete</button>
                            )
                        }
                    </div>
                </div>
            </>
        )
    }
    return <Dialog {...props} title={<CustomTitle />} width="38%" />;
};